import { useAppInitDetails } from "hooks/use-app-init-details/use-app-init-details.hook";

// `get_app_init_details` is one of the socket paths where the SDK does NOT
// camelCase the response — read both shapes so we're resilient if the SDK
// ever fixes the transform.
export const useJourneyNavEnabled = () => {
  const { data, isLoading, error } = useAppInitDetails();

  const contentConfig =
    (data as { contentConfig?: Record<string, string | null | undefined> })
      ?.contentConfig ??
    (data as { content_config?: Record<string, string | null | undefined> })
      ?.content_config;
  const journeyConfigRaw = contentConfig?.journey;

  let enabled = false;
  if (journeyConfigRaw) {
    try {
      const parsed = JSON.parse(journeyConfigRaw) as Record<string, unknown>;
      enabled = parsed["nav-enabled"] === true;
    } catch {
      enabled = false;
    }
  }

  return { enabled, isLoading, error };
};
